import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = ({ title }: { title: string }) => {
  const location = useLocation();

  useEffect(() => {
    const originalTitle = document.title; // Save the original title

    document.title = `Hailing Trades/${title}`; // Set the new title

    return () => {
      document.title = originalTitle; // Restore the original title on unmount
    };
  }, [location, title]);

  return null;
};

export default PageTitle;
